var exports = {
  "e": "CollapseButton__aNk7bt",
};

module.exports = exports;
